import script from "./judicativeList.vue?vue&type=script&setup=true&lang=js"
export * from "./judicativeList.vue?vue&type=script&setup=true&lang=js"

import "./judicativeList.vue?vue&type=style&index=0&id=1ce10813&lang=css"
import "./judicativeList.vue?vue&type=style&index=1&id=1ce10813&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce10813"]])

export default __exports__